import React from "react"
import PropTypes from "prop-types"
import shortid from "shortid"
import { Link } from "gatsby"

const Breadcrumbs = ({ breadcrumbs }) => {
  const getBreadcrumb = (breadcrumb, index) => {
    if (index + 1 === breadcrumbs.length) {
      return (
        <span key={shortid.generate()}>{breadcrumb.name.toLowerCase()}</span>
      )
    }

    return (
      <span key={shortid.generate()}>
        <Link to={breadcrumb.path}>{`${breadcrumb.name.toLowerCase()}`}</Link>
        {" // "}
      </span>
    )
  }

  return (
    <span className="breadcrumb">
      {breadcrumbs.map((breadcrumb, index) => getBreadcrumb(breadcrumb, index))}
    </span>
  )
}

export default Breadcrumbs

Breadcrumbs.propTypes = {
  breadcrumbs: PropTypes.array.isRequired,
}
